import React from 'react';
import { motion } from 'framer-motion';

export const NotifyTestIcon: React.FC<{ isActive: boolean }> = ({
	isActive,
}) => {
	return (
		<motion.svg
			animate={isActive ? { scale: 1.15 } : null}
			width="100%"
			height="100%"
			viewBox="0 0 64 64"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				x="13.75"
				y="10.75"
				width="36.5"
				height="46.5"
				rx="3.25"
				stroke="#F27C00"
				stroke-width="1.5"
			/>
			<path
				d="M41.8794 10.0177V8.83632C41.8778 8.58512 41.7769 8.34474 41.5987 8.16767C41.4206 7.9906 41.1796 7.89121 40.9284 7.89122H37.8154C37.5868 7.88971 37.3661 7.80687 37.1929 7.65751C37.0198 7.50816 36.9054 7.30204 36.8703 7.07607C36.6666 5.93339 36.0672 4.89883 35.1774 4.1536C34.2875 3.40838 33.1638 3 32.0031 3C30.8424 3 29.7186 3.40838 28.8288 4.1536C27.9389 4.89883 27.3396 5.93339 27.1358 7.07607C27.102 7.30155 26.9889 7.50756 26.8167 7.65701C26.6445 7.80645 26.4246 7.88951 26.1966 7.89122H23.0778C22.8337 7.89721 22.6013 7.99684 22.4286 8.16947C22.256 8.34211 22.1564 8.57453 22.1504 8.8186V14.2706C22.152 14.5218 22.2528 14.7622 22.431 14.9393C22.6092 15.1164 22.8502 15.2158 23.1014 15.2157H40.9284C41.1796 15.2158 41.4206 15.1164 41.5987 14.9393C41.7769 14.7622 41.8778 14.5218 41.8794 14.2706V10.0177Z"
				fill="#F27C00"
			/>
			<path
				d="M32.0032 10.3245C33.0242 10.3245 33.852 9.502 33.852 8.48743C33.852 7.47286 33.0242 6.65039 32.0032 6.65039C30.9821 6.65039 30.1543 7.47286 30.1543 8.48743C30.1543 9.502 30.9821 10.3245 32.0032 10.3245Z"
				fill="white"
			/>
			<path
				d="M41 25H23V43H41V25Z"
				stroke="#F27C00"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M27.5 31.8845L33.0023 37.3867L45.389 25"
				stroke="#F27C00"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</motion.svg>
	);
};
